import { CheckCircle, XCircle, MapPin, Shield } from "lucide-react";
import { useEffect, useState } from "react";
import { approveVolunteer, pendingvol } from "../../services/mainService";

const pendingVolunteers = [
  {
    id: 1,
    name: "Ahmed Rahim",
    area: "Delhi",
    appliedOn: "14 Jan 2026",
    documents: "ID + Address Proof",
  },
  {
    id: 2,
    name: "Zara Noor",
    area: "Mumbai",
    appliedOn: "15 Jan 2026",
    documents: "ID Proof",
  },
];

const VolunteerPending = () => {
  const [pendingVolunteers, setPendingVolunteers] = useState([]);
  const [pagination, setpagination] = useState({
    current_page: 1,
    per_page: 10,
  });
  const [selectedVolunteer, setSelectedVolunteer] = useState(null);
  const [password, setPassword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchvolunteer();
  }, []);

  const fetchvolunteer = async () => {
    try {
      const res = await pendingvol({ page: pagination.current_page });
      console.log(res);

      setPendingVolunteers(res.data);
      setpagination(res.pagination_info);
    } catch (err) {
      console.error("Error fetching causes:", err);
    } finally {
    }
  };

  const handleApproveClick = (volunteer) => {
    setSelectedVolunteer(volunteer);
    setShowModal(true);
  };

  const confirmApprove = async () => {
    if (!password) {
      alert("Please enter password");
      return;
    }

    try {
      setLoading(true);

      await approveVolunteer({
        volunteer_id: selectedVolunteer.id,
        status: 1,
        password: password,
      });

      setShowModal(false);
      setPassword("");
      fetchvolunteer();
    } catch (err) {
      alert("Incorrect password or approval failed");
    } finally {
      setLoading(false);
    }
  };
  const Reject = async (vol) => {
    try {
      setLoading(true);

      await approveVolunteer({
        volunteer_id: vol.id,
        status: 2,
      });

      fetchvolunteer();
    } catch (err) {
      alert("volunteer not rejected");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="allcause-page">
      <header className="page-header">
        <h2>Pending Volunteers</h2>
        <p>Approval required before assigning verification tasks</p>
      </header>
      {pendingVolunteers.length === 0 ? (
        <div className="empty-state">
          <Shield size={64} />
          <h3>No pending volunteers found</h3>
        </div>
      ) : (
        <div className="allcause-card">
          <table className="allcause-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone Number</th>
                <th>Email</th>
                <th>Applied On</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {pendingVolunteers.map((vol) => (
                <tr key={vol.id}>
                  <td>
                    {/* <img
                    src={vol.profile_pic}
                    alt={vol.fullname}
                    className="volunteer-image"
                  /> */}
                    {vol.fullname}
                  </td>
                  <td>{vol.phone_number}</td>

                  <td>{vol.email}</td>
                  <td>{vol.created_time}</td>
                  <td className="actions">
                    <button
                      className="btn approve"
                      onClick={() => handleApproveClick(vol)}
                    >
                      <CheckCircle size={14} /> Approve
                    </button>
                    <button className="btn reject" onClick={() => Reject(vol)}>
                      <XCircle size={14} /> Reject
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Confirm Approval</h3>
            <p>
              Set password for <strong>{selectedVolunteer?.fullname}</strong>
            </p>

            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <div className="modal-actions">
              <button
                className="btn cancel"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>

              <button
                className="btn approve"
                onClick={confirmApprove}
                disabled={loading}
              >
                {loading ? "Approving..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VolunteerPending;
